import { createSvgIcon } from '@material-ui/core/utils';

export const BlueprintIcon = createSvgIcon(
  <>
    <path d="M17.38 2.67H6.62L1.23 12l5.39 9.32h10.76L22.77 12l-5.39-9.33ZM8.62 16.91V6.34h3.62c1.2 0 2.11.24 2.73.72.62.48.94 1.19.94 2.14 0 .48-.13.92-.39 1.31s-.64.69-1.15.9c.57.16 1.01.45 1.33.87.31.43.47.94.47 1.54 0 .99-.32 1.75-.96 2.29s-1.55.8-2.73.8H8.62Zm1.84-6.12h1.8c.57 0 1.02-.13 1.34-.39s.48-.63.48-1.1c0-.52-.15-.9-.45-1.13-.3-.23-.76-.35-1.39-.35h-1.79v2.97Zm0 1.35v3.3h2.04c.58 0 1.03-.14 1.35-.43.32-.29.49-.68.49-1.19 0-1.1-.56-1.66-1.69-1.69h-2.19Z" />
  </>,
  'BlueprintIcon',
);
